export const parseId = (string: unknown): number | null => {
  const id = Number(string);
  return Number.isSafeInteger(id) && id > 0 ? id : null;
};
